var plugin = require('tailwindcss/plugin');

var _ = require('lodash');

module.exports = plugin(function (_ref) {
  var theme = _ref.theme,
      variants = _ref.variants,
      e = _ref.e,
      addUtilities = _ref.addUtilities;

  var aspectRatioUtilities = _.fromPairs(_.map(theme('aspectRatio'), function (value, modifier) {
    var aspectRatio = _.isArray(value) ? value[0] / value[1] : value;
    return [".".concat(e("aspect-ratio-".concat(modifier))), {
      paddingBottom: aspectRatio == 0 ? '0' : "".concat(1 / aspectRatio * 100, "%")
    }];
  }));

  addUtilities(aspectRatioUtilities, variants('aspectRatio'));
}, {
  theme: {
    aspectRatio: {}
  },
  variants: {
    aspectRatio: ['responsive']
  }
});